// extracted by mini-css-extract-plugin
module.exports = {"chicklet_shape":"menu_popover_chicklet_shape__mv9CV"};